import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { setEstimateItems, setCartItem } from 'estimate_list/libs/action'
import { getImage, getImageError } from 'estimate_list/libs/item'
import { numberFormat, estimate, scrollTo } from 'estimate_list/libs/util'

class Item extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            stdPcOpen: '',
            stdPcToggleIcon: 'icon-add',
            searchData: this.props.searchData,
            displayInfo: { display: 'none' },
        }
    }

    componentWillMount() {
        this.setState({ searchData: this.props.searchData })
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ searchData: nextProps.searchData })
    }

    stdpcToggle(_e) {
        if (this.state.stdPcOpen === '') {
            this.setState({ stdPcOpen: 'open', stdPcToggleIcon: 'icon-remove' })
        } else {
            this.setState({ stdPcOpen: '', stdPcToggleIcon: 'icon-add' })
        }
    }

    addCartItem(_mall) {
        if (this.props.userInfo === null) {
            window.location.href = process.env.REACT_APP_SSO_URL
            return false
        }

        const item = this.props.setItem
        let mallInfo = item.seller_col.split('|')
        let cartItem = {}
        cartItem.seller = mallInfo[3]
        cartItem.cate_id = item.cate_id
        cartItem.item_id = item.item_id
        this.props.setCartItem(cartItem)
    }

    addEstimateItem(itemId) {
        let estimateItems = estimate.addEstimateItem(itemId)
        this.props.setEstimateItems({ estimateItems, type: 'add', itemId: itemId })
        this.onMoveEstimate()
    }

    addCompareItems(itemId, compareData) {
        // console.log(itemId, compareData)
        const compareItems = estimate.addCompareItems(itemId, compareData)
        this.props.setCompareItems(compareItems)
    }

    onMoveEstimate() {
        scrollTo('#estimateList')
    }

    render() {
        if (this.props.setItem === undefined) return false
        const item = this.props.setItem
        const itemMedium = this.props.itemMedium

        let categoryDiv = this.props.domain === 'shopping' ? 1 : 0 // 0 견적 1 쇼핑

        let thumbnail = getImage(item.cate_id, item.item_id, 300)

        // stdpc
        let stdPcList = false
        if (item.stdpclist) {
            let stdpc = item.stdpclist.split('^')
            stdPcList = stdpc.map(v => {
                return v.split('|')
            })
        }

        // item_br_info
        let itemSpecInfo = []
        if (item.item_br_info) {
            itemSpecInfo = item.item_br_info.split(' / ')
        }

        let regDate = item.date_launch.split('-')

        let price = numberFormat(item.price_low)
        if (item.f_sellout !== 0) price = 0

        return (
            <Style className="mediumguide_main_box">
                <h3 className="tit-h3">
                    <a href={`${process.env.REACT_APP_SHOPPING_URL}/${item.cate_id}/${item.item_id}/`} target="_blank" rel="noopener noreferrer">
                        {item.maker_name} {item.item_name}
                    </a>
                </h3>

                <div className="mediumguide_main_box_item happytree">
                    <div className="thumb">
                        <a href={`${process.env.REACT_APP_SHOPPING_URL}/${item.cate_id}/${item.item_id}/`} target="_blank" rel="noopener noreferrer">
                            <img
                                src={thumbnail.imgUrl}
                                onError={e => getImageError(e, thumbnail.noImgUrl)}
                                alt={item.item_name}
                            />
                        </a>

                        {/* <button type="button" className="btn-happytree"><span className="ir">해피트리</span></button> */}
                    </div>

                    <div className="price">
                        {price.toString() === '0' ? (
                            <span className="price_lower">
                                <strong style={{ color: '#999' }}>가격비교 예정</strong>
                            </span>
                        ) : (
                            <React.Fragment>
                                <span className="price_lower">
                                    최저 <strong>{numberFormat(price)}</strong>원
                                </span>

                                {categoryDiv === 1 ? (
                                    <>
                                        {/* <button type="button" className="btn-cart-to" onClick={() => this.addCartItem()}>
                                            <span>장바구니 담기</span>
                                        </button> */}
                                    </>
                                ) : (
                                    <button
                                        type="button"
                                        className="btn-add-to"
                                        onClick={() => this.addEstimateItem(item.item_id)}
                                    >
                                        <span>상품견적 담기</span>
                                    </button>
                                )}
                            </React.Fragment>
                        )}
                    </div>
                </div>

                <div className="mediumguide_main_box_in">
                    <div className="speclist">
                        {itemSpecInfo.map((v, i) => {
                            return <span key={i}>{v}</span>
                        })}
                    </div>

                    <div className="bot_info">
                        <ul>
                            <li className="cell_grade">
                                <div className="product_grade">
                                    <span className="t">상품평</span>
                                    <span className="star">
                                        <span className="star_grade" style={{ width: item.rating_ureview * 10 + '%' }}>
                                            <span className="star_grade_point">
                                                <em>{item.rating_ureview}</em>
                                            </span>
                                        </span>
                                    </span>
                                </div>
                            </li>
                            <li className="cell_date">출시일 {regDate[0] + '.' + regDate[1]}</li>
                            <li>
                                {/* <button
                                    type="button"
                                    className={'btn_item_fork' + (item.myZzimCount > 0 ? ' active' : '')}
                                >
                                    <i className="icon-favorite_border" /> 찜하기{' '}
                                    <span className="cnt">{item.zzimCount}</span>
                                </button> */}
                                <i className="icon-favorite_border" /> 찜하기 <span className="cnt">{item.zzimCount}</span>
                            </li>
                        </ul>
                    </div>

                    <div className="related_info">
                        {stdPcList && (
                            <dl>
                                <dt>
                                    행쇼 표준PC <span>{stdPcList.length}</span>
                                </dt>
                                <dd>
                                    <ul className={this.state.stdPcOpen}>
                                        {stdPcList.map((v, i) => {
                                            return (
                                                <li key={i}>
                                                    <a
                                                        href={`${process.env.REACT_APP_SHOPPING_URL}/${v[2]}/${v[0]}/`}
                                                        rel="noopener noreferrer"
                                                        target="_blank"
                                                    >
                                                        {v[1]}
                                                    </a>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                    <button type="button" className="btn_list_more" onClick={e => this.stdpcToggle(e)}>
                                        <i className={this.state.stdPcToggleIcon} />
                                        <span className="ir">열기</span>
                                    </button>
                                </dd>
                            </dl>
                        )}
                    </div>

                    <div className="mediumguide_main_box_medium">
                        <img
                            src={`${process.env.REACT_APP_CDN_IMG}/img_static/img_pres/_v3/ico_mediumguide.jpg`}
                            alt="미디엄 가이드"
                        />
                        <h4 className="tit-h4">{itemMedium.title}</h4>
                        <div className="mediumguide_main_box_medium_conts">
                            {itemMedium.subtxt}
                            <a href={'#key' + item.item_id} className="more">
                                더보기 <i className="icon-triangle-right" />
                            </a>
                        </div>
                    </div>
                </div>
            </Style>
        )
    }
}

const Style = styled.div`
    position: relative;
    padding: 30px 10px;
    border-top: 1px solid #ccc;

    &:hover {
        background: #f5f9fe;

        .thumb {
            outline: 1px solid #418ded;
        }
    }
    .tit-h3 {
        font-size: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .ir {
        visibility: hidden;
        overflow: hidden;
        position: absolute;
        width: 1%;
        height: 1%;
        margin: 0;
        padding: 0;
        font-size: 1%;
        line-height: 1%;
    }
    .btn-add-to, .btn-cart-to {
        overflow: hidden;
        position: relative;
        border: 0;
        color: #fff;
        background-color: #418ded;
        vertical-align: middle;
        letter-spacing: 0;
        cursor: pointer;
        box-sizing: border-box;
    }
    .btn-add-to:hover, .btn-cart-to:hover {
        overflow: visible;
    }
    .mediumguide_main_box_item {
        position: absolute;
        right: 10px;
        top: 70px;
        width: 200px;

        .thumb {
            position: relative;

            a {
                display: block;

                img {
                    max-width: 100%;
                }
            }
        }
        .price {
            margin-top: 10px;
            font-size: 13px;
            text-align: right;

            .price_lower {
                display: inline-block;
                height: 27px;
                padding: 0 5px;
                font-size: 12px;
                color: #999;
                line-height: 27px;
                vertical-align: top;

                strong {
                    display: inline-block;
                    height: 27px;
                    font-size: 18px;
                    color: #f34522;
                }
            }
            button {
                width: 27px;
                height: 27px;
                line-height: 27px;
            }
        }
    }
    .mediumguide_main_box_in {
        margin-right: 230px;
        min-height: 240px;

        .speclist {
            margin-top: 15px;
            font-size: 0;
            line-height: 1.5;

            span {
                position: relative;
                display: inline-block;
                margin-right: 10px;
                padding-right: 11px;
                font-size: 12px;
                color: #999;
                vertical-align: top;
                /* cursor: pointer; */
            }
        }
        .bot_info {
            margin-top: 15px;

            &:after {
                content: '';
                display: block;
                clear: both;
            }
            li {
                position: relative;
                float: left;
                margin-right: 10px;
                padding-right: 11px;
                color: #999;
                line-height: 20px;

                &:last-child {
                    &:after {
                        content: none
                    }
                }
                &:after {
                    content: "";
                    position: absolute;
                    right: 0;
                    top: 5px;
                    width: 1px;
                    height: 12px;
                    background: #dbdbdb;
                }

                .product_grade {
                    margin: 4px 14px 0 0;
                    line-height: 1;

                    span {
                        display: inline-block;
                        height: 13px;
                        vertical-align: top;
                    }
                    .t {
                        margin-right: 3px;
                    }
                    .star {
                        position: relative;
                        width: 85px;
                        background: ${'url('+ process.env.REACT_APP_CDN_IMG +'/img_static/img_pres/_v3/sprite_1.png) no-repeat -344px -172px'};

                        .star_grade {
                            background: ${'url(' + process.env.REACT_APP_CDN_IMG +'/img_static/img_pres/_v3/sprite_1.png) -344px -185px'};

                            .star_grade_point {
                                position: absolute;
                                left: 90px;
                                top: 0;
                                line-height: 13px;
                                letter-spacing: 0;

                                em {
                                    color: #418ded;
                                }
                            }
                        }
                    }
                }
                .cnt {
                    color: #418ded;
                }
            }
        }
        .related_info {
            margin-top: 10px;

            dl {
                margin-top: 2px;

                &:after {
                    display: block;
                    clear: both;
                    height: 0;
                    font-size: 0;
                    line-height: 0;
                    content: '';
                }
                dt {
                    float: left;
                    width: 90px;
                    line-height: 22px;
                    font-weight: bold;

                    span {
                        color: #418ded;
                    }
                }
                dd {
                    overflow: hidden;
                    position: relative;
                    padding-left: 18px;

                    ul {
                        overflow: hidden;
                        height: 22px;

                        &.open {
                            height: auto;
                        }
                        li {
                            line-height: 22px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;

                            a {
                                color: #666;

                                &:hover {
                                    text-decoration: underline
                                }
                            }
                        }
                    }
                    .btn_list_more {
                        position: absolute;
                        left: 0;
                        top: 4px;
                        line-height: 1;
                        width: 14px;
                        height: 14px;
                        border: 1px solid #ccc;
                        color: #f34522;
                        background-color: #fff;
                        vertical-align: middle;
                        letter-spacing: 0;
                        cursor: pointer;
                        box-sizing: border-box;
                    }
                }
            }
        }
        .mediumguide_main_box_medium {
            margin-top: 15px;
            padding: 20px;
            border: 1px solid #ccc;
            background: #fff;

            .tit-h4 {
                margin-top: 10px;
                font-size: 14px;
            }
            .mediumguide_main_box_medium_conts {
                margin-top: 6px;
                line-height: 1.7;
                word-break: keep-all;
                word-wrap: break-word;
            }
            .more {
                position: relative;
                top: -2px;
                display: inline-block;
                padding: 0 5px;
                height: 22px;
                border: 0;
                color: #418ded;
                background-color: rgba(0,0,0,0);
                text-align: center;
                line-height: 22px;
                vertical-align: middle;
                letter-spacing: 0;
                cursor: pointer;
                box-sizing: border-box;
            }
        }
    }
`

let stateData = state => {
    return {
        selectCategory: state.initial.selectCategory,
        domain: state.initial.domain,
    }
}

let dispatchData = dispatch => {
    return {
        setEstimateItems: estimateItems => dispatch(setEstimateItems(estimateItems)),
        setCartItem: cartItem => dispatch(setCartItem(cartItem)),
    }
}

export default connect(
    stateData,
    dispatchData,
)(Item)



// WEBPACK FOOTER //
// ./src/estimate_list/components/medium/item.js